import process from "node:process";
import { useTurnstileSiteKey } from "@calcom/web/modules/auth/hooks/useTurnstileSiteKey";
import type { TurnstileProps } from "react-turnstile";
import Turnstile from "react-turnstile";

type Props = Omit<TurnstileProps, "sitekey">;

export default function TurnstileWidget(props: Props) {
  const sitekey = useTurnstileSiteKey();
  if (!sitekey || process.env.NEXT_PUBLIC_IS_E2E) return null;

  return <Turnstile {...props} sitekey={sitekey} theme="auto" />;
}
